import { render } from "./DetalleMontosOperacion.vue?vue&type=template&id=5158ba6e&scoped=true"
import script from "./DetalleMontosOperacion.vue?vue&type=script&lang=js"
export * from "./DetalleMontosOperacion.vue?vue&type=script&lang=js"

import "./DetalleMontosOperacion.vue?vue&type=style&index=0&id=5158ba6e&scoped=true&lang=css"

import exportComponent from "C:\\AgentesAzure\\SVRAPQAHIR01\\vsts-agent-win-x64-4.261.0\\_work\\31\\s\\CCD\\hircasa-ccd-webapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5158ba6e"]])

export default __exports__